import * as React from "react";
import {Component, ReactNode} from "react";
import {FormFeedback, FormGroup} from "reactstrap";
import {WrappedFieldProps} from "redux-form";
import {InputType} from "reactstrap/lib/Input";

export interface IFormRendererProps extends WrappedFieldProps {
    label: string;
    type?: InputType;
    className?: string;
    hideMessages?: boolean;
}

export default class FormRenderer extends Component<IFormRendererProps> {
    public render(): ReactNode {
        const {
            type,
            children,
            className = "",
            hideMessages,
            meta: {error, warning, pristine}
        } = this.props;

        return (
            <FormGroup check={type === "checkbox"} className={`${type === "checkbox" ? "mr-0" : ""} ${className}`}>
                {children}
                {!pristine && !hideMessages && (
                    ((error && <FormFeedback>{error}</FormFeedback>) ||
                        (warning && <FormFeedback>{warning}</FormFeedback>))
                )}
            </FormGroup>
        );
    }
}